import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'config/reactQuery'
import { AccountService } from 'services/account'
import { PaymentMethodRequest } from 'services/account/types'

async function savePaymentMethod(request: PaymentMethodRequest) {
  return await AccountService.savePaymentMethod(request)
}

export const usePostPaymentMethod = () => {
  const { isLoading, mutate, error, status } = useMutation(
    (request: PaymentMethodRequest) => savePaymentMethod(request),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['userId'])
      },
    },
  )

  return { isLoading, mutate, error, status }
}
